// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ae2JC","title":"style__title__aq7dI","list":"style__list__UnGwc"};